export const chatEndpoints = {
  chats: '/ai/conversations',
  chat: '/ai/conversations/{id}',
  messages: '/ai/conversations/{id}/messages',
  actions: '/ai/conversations/{id}/actions',
} as const;

/** How often an open chat checks again while a reply is still being written. */
export const PENDING_REPLY_POLL_MS = 2000;
